import { render, staticRenderFns } from "./BoxMedicos.vue?vue&type=template&id=04b7aeea&"
import script from "./BoxMedicos.vue?vue&type=script&lang=js&"
export * from "./BoxMedicos.vue?vue&type=script&lang=js&"
import style0 from "./BoxMedicos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports